import type { CurrentUser } from "./types";

export function hasPermission(user: CurrentUser | Pick<CurrentUser, "permissions"> | null, key: string): boolean {
  if (!user) return false;
  return user.permissions.includes(key);
}

export function usePermissions(user: CurrentUser | null): {
  permissions: string[];
  hasPermission: (key: string) => boolean;
} {
  const permissions = user?.permissions ?? [];
  return {
    permissions,
    hasPermission: (key: string) => permissions.includes(key),
  };
}

/**
 * Whether the person holds a permission in one organization (docs/adr/0017). Installation-wide
 * permissions (held, but not tied to any organization) count everywhere.
 */
export function canIn(user: CurrentUser | null, permission: string, organizationId: string): boolean {
  if (!user) return false;
  if (user.permissionsByOrganization[organizationId]?.includes(permission)) return true;
  const inSomeOrganization = Object.values(user.permissionsByOrganization).some((keys) => keys.includes(permission));
  return !inSomeOrganization && user.permissions.includes(permission);
}
